export default "__VITE_ASSET__q2UZ7HuK__"